module.exports = __webpack_public_path__ + "img/header.d80bccd9.png";